import {
  Divider,
  Flexbox,
  Heading1,
  PageHeader,
  ToolButton
} from '@ibinder/common-frontend';
import React from 'react';
import BreadcrumbsComponent from './BreadcrumbsComponent';
import styled from 'styled-components';
import { menuBars } from '@ibinder/common-icons';

const PageHeaderHeight = styled(PageHeader)`
  min-height: 5rem;
  height: auto;
  margin-bottom: 0;

  h1 {
    line-height: unset;
  }
`;
const AlignToTop = styled.div`
  align-self: start;
`;

const RegisterHeader = ({ tabs, rightPanelOpen, toggleTabsMenu, nodeData }) => {
  return (
    <>
      <PageHeaderHeight>
        <Flexbox justifyContent="space-between" alignItems="center">
          <Heading1 loading={false} label={nodeData.value.name} />
          <AlignToTop>
            <ToolButton
              active={rightPanelOpen}
              type="button"
              onClick={toggleTabsMenu}
            >
              {menuBars}
            </ToolButton>
          </AlignToTop>
        </Flexbox>
      </PageHeaderHeight>

      <BreadcrumbsComponent tabs={tabs} nodeData={nodeData} />
    </>
  );
};

export default RegisterHeader;
